/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface PatientInfoDto
 */
export interface PatientInfoDto {
  /**
   * Unique identifier of the patient.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  p_id: string;

  /**
   * List of organization IDs associated with the patient.
   *
   * @type {Array<string>}
   * @memberof PatientInfoDto
   * @example ["2d715b1b-6618-452a-aa6e-57efa4405d36"]
   */
  o_ids: Array<string>;

  /**
   * Date of birth of the patient.
   *
   * @type {any}
   * @memberof PatientInfoDto
   * @example 1980-01-01
   */
  birth_date: any;

  /**
   * Sex of the patient.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example M
   */
  sex: PatientInfoDtoSexEnum;

  /**
   * List of diagnosed pathologies of the patient.
   *
   * @type {Array<string>}
   * @memberof PatientInfoDto
   * @example ["Diabetes","Hypertension"]
   */
  pathology: Array<string>;

  /**
   * List of diagnosed conditions of the patient.
   *
   * @type {Array<string>}
   * @memberof PatientInfoDto
   * @example ["Arthritis"]
   */
  affectation: Array<string>;

  /**
   * City of residence of the patient.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example New York
   */
  country: string;

  /**
   * Nationality of the patient.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example es
   */
  nationality: string;

  /**
   * The patient cp
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example 28500
   */
  cp: string;

  /**
   * If the patient is blocked
   *
   * @type {boolean}
   * @memberof PatientInfoDto
   * @example false
   */
  blocked?: boolean;

  /**
   * Patient highest score in sessions.
   *
   * @type {number}
   * @memberof PatientInfoDto
   * @example 95
   */
  best_score?: number;

  /**
   * Patient weight.
   *
   * @type {number}
   * @memberof PatientInfoDto
   * @example 70
   */
  weight: number;

  /**
   * Patient height.
   *
   * @type {number}
   * @memberof PatientInfoDto
   * @example 175
   */
  height: number;

  /**
   * Weight units.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example kg
   */
  weight_units?: string;

  /**
   * Height units.
   *
   * @type {string}
   * @memberof PatientInfoDto
   * @example cm
   */
  height_units?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientInfoDtoSexEnum {
  M = 'M',
  F = 'F',
}
